<ng-container *transloco="let convert;">
  <div
    class="modal--action-list"
    role="dialog"
    aria-modal="true"
    aria-labelledby="make-removed-modal-title"
    [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelMakeRemovedModal')"
    [attr.data-track-region]="headline"
  >
    <header class="modal__header">
      <h1 class="modal__title" id="make-removed-modal-title" tabindex="-1">
        {{ headline }}
      </h1>
    </header>

    <div class="modal__content">
      <div
        class="modal__body"
        [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelSelectedMessage')">
        <div class="vehicle-info__row" [innerHtml]="modalBody">
        </div>
      </div>

      <div class="modal__actions">
        <button
          class="btn btn-primary me-md-2 mb-3 mb-md-0"
          data-track-elem="button"
          data-track-name="Search"
          allytmln="Yes, Remove"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelYesRemove')"
          (click)="changeStatus(inventoryManagementAuctionItemStatus.REMOVED)">
          {{convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelYesRemove')}}
        </button>
        <button
          class="btn cancel btn-link outline-focus ms-md-2"
          allytmln="No, Don’t Remove"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelNoDontRemove')"
          (click)="closeModal()">
          <span>{{convert('sellModule.manageInventory.actionListModal.makeRemovedModal.ariaLabelNoDontRemove')}}</span>
        </button>

      </div>
    </div>

    @if (configuration$()) {
      <button
        class="modal__close"
        data-dismiss="modal"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="closeModal()"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close">
        <img
          src="../../../../../ui/assets/assets-{{ configuration$().tenantName }}/{{ configuration$().tenantName }}-close.svg"
          alt="{{convert('common.altCloseModelIcon')}}"/>
      </button>
    }
  </div>
</ng-container>
